import { type UseQueryOptions } from '@tanstack/react-query';
import { useFavoritePairings } from './useFavoritePairings';

type GetFavoritePairingParams = {
  pairingId: number;
};

type OptionType = Pick<UseQueryOptions, 'enabled'>;

export function useFavoritePairing(
  queryParams: GetFavoritePairingParams,
  options: OptionType = {}
) {
  let isFavorited = false;

  const result = useFavoritePairings(options);

  if (!result.isLoading && result.data && result.data.favorite_pairings) {
    isFavorited =
      result.data.favorite_pairings.findIndex(
        (p) => p.pairing_id === queryParams.pairingId
      ) >= 0;
  }

  return { ...result, isFavorited };
}
